<template>
  <div class="overflow-x-auto border rounded-lg bg-white mb-5 mt-4">
    <table class="min-w-full text-sm">
      <thead class="bg-gray-50 text-gray-600">
        <tr class="cursor-pointer select-none" @click="toggleCollapsed">
          <th class="text-left px-3 py-2">
            <span class="inline-flex items-center gap-2">
              <span class="text-gray-500">{{ isCollapsed ? '▸' : '▾' }}</span>
              {{ title }}
            </span>
          </th>
          <slot name="head" />
        </tr>
      </thead>
      <tbody v-if="!isCollapsed">
        <slot />
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'AccordionTable',
  props: {
    collapsed: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    isCollapsed: {
      get() {
        return this.collapsed
      },
      set(value) {
        this.$emit('update:collapsed', value)
      },
    },
  },
  methods: {
    toggleCollapsed() {
      this.isCollapsed = !this.isCollapsed
    },
  },
}
</script>
